// // import { lazy } from 'react';

// // const Home = lazy(() => import('../features/home/Home'));
// // const CourtsList = lazy(() => import('../features/courts/Courts').then((m) => ({ default: m.CourtsList })));
// // const BookCourt = lazy(() => import('../features/courts/Courts').then((m) => ({ default: m.BookCourt })));
// // const TournamentsList = lazy(() => import('../features/tournaments/Tournaments').then((m) => ({ default: m.TournamentsList })));
// // const TournamentReg = lazy(() => import('../features/tournaments/Tournaments').then((m) => ({ default: m.TournamentRegister })));
// // const LiveMatches = lazy(() => import('../features/live-matches/LiveMatches'));
// // const CoachesList = lazy(() => import('../features/coaches/Coaches').then((m) => ({ default: m.CoachesList })));
// // const BookCoach = lazy(() => import('../features/coaches/Coaches').then((m) => ({ default: m.BookCoach })));
// // const MyTournaments = lazy(() => import('../features/my-tournaments/MyTournaments'));
// // const MyBookings = lazy(() => import('../features/my-bookings/MyBookings'));
// // const Profile = lazy(() => import('../features/profile/Profile'));
// // const Login = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.Login })));
// // const Register = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.Register })));
// // const ForgotPassword = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.ForgotPassword })));
// // const AboutUs =lazy(()=> import('../features/info/about_us'));
// // const ContactUs =lazy(()=> import('../features/info/contact_us'));

// // export const publicRoutes = [
// //     { path: '/login', component: Login },
// //     { path: '/register', component: Register },
// //     { path: '/forgot-password', component: ForgotPassword },
// //     { path: '/', component: Home },
// //     { path: '/courts', component: CourtsList },
// //     { path: '/tournaments', component: TournamentsList },
// //     { path: '/live-matches', component: LiveMatches },
// //     { path: '/coaches', component:CoachesList},
// //     // { path: '/my-tournaments', component: MyTournaments },
// //     // { path: '/my-bookings', component: MyBookings },
// //     { path: '/aboutus', component:AboutUs},
// //     { path: '/contactus', component:ContactUs},

// // ];

// // export const protectedRoutes = [
// //     { path: '/courts/:id/book', component: BookCourt },
// //     { path: '/tournaments/:id/register', component: TournamentReg },
// //     { path: '/coaches', component: CoachesList },
// //     { path: '/coaches/:id/book', component: BookCoach },
// //     { path: '/my-tournaments', component: MyTournaments },
// //     { path: '/my-bookings', component: MyBookings },
// //     { path: '/profile', component: Profile },
// // ];
// // import { lazy } from 'react';

// // const Home           = lazy(() => import('../features/home/Home'));
// // const CourtsList     = lazy(() => import('../features/courts/Courts').then((m) => ({ default: m.CourtsList })));
// // const BookCourt      = lazy(() => import('../features/courts/Courts').then((m) => ({ default: m.BookCourt })));
// // const TournamentsList = lazy(() => import('../features/tournaments/Tournaments').then((m) => ({ default: m.TournamentsList })));
// // const TournamentReg  = lazy(() => import('../features/tournaments/Tournaments').then((m) => ({ default: m.TournamentRegister })));
// // const LiveMatches    = lazy(() => import('../features/live-matches/LiveMatches'));
// // const CoachesList    = lazy(() => import('../features/coaches/Coaches').then((m) => ({ default: m.CoachesList })));
// // const BookCoach      = lazy(() => import('../features/coaches/Coaches').then((m) => ({ default: m.BookCoach })));
// // const MyTournaments  = lazy(() => import('../features/my-tournaments/MyTournaments'));
// // const MyBookings     = lazy(() => import('../features/my-bookings/MyBookings'));
// // const Profile        = lazy(() => import('../features/profile/Profile'));
// // const Login          = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.Login })));
// // const Register       = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.Register })));
// // const ForgotPassword = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.ForgotPassword })));
// // const AboutUs        = lazy(() => import('../features/info/about_us'));
// // const ContactUs      = lazy(() => import('../features/info/contact_us'));
// // const BookOneOnOne   = lazy(() => import('../features/book-one-on-one/one_on_one')); // ← NEW


// // export const publicRoutes = [
// //   { path: '/login',            component: Login },
// //   { path: '/register',         component: Register },
// //   { path: '/forgot-password',  component: ForgotPassword },
// //   { path: '/',                 component: Home },
// //   { path: '/courts',           component: CourtsList },
// //   { path: '/tournaments',      component: TournamentsList },
// //   { path: '/live-matches',     component: LiveMatches },
// //   { path: '/coaches',          component: CoachesList },
// //   { path: '/book-one-on-one',  component: BookOneOnOne },   // ← NEW
// //   // { path: '/my-tournaments', component: MyTournaments },
// //   // { path: '/my-bookings',    component: MyBookings },
// //   { path: '/aboutus',          component: AboutUs },
// //   { path: '/contactus',        component: ContactUs },
// // ];


// // export const protectedRoutes = [
// //   { path: '/courts/:id/book',          component: BookCourt },
// //   { path: '/tournaments/:id/register', component: TournamentReg },
// //   { path: '/coaches',                  component: CoachesList },
// //   { path: '/coaches/:id/book',         component: BookCoach },
// //   { path: '/my-tournaments',           component: MyTournaments },
// //   { path: '/my-bookings',              component: MyBookings },
// //   { path: '/profile',                  component: Profile },
// // ];
// import { lazy } from 'react';

// const Home            = lazy(() => import('../features/home/Home'));
// const CourtsList      = lazy(() => import('../features/courts/Courts').then((m) => ({ default: m.CourtsList })));
// const BookCourt       = lazy(() => import('../features/courts/Courts').then((m) => ({ default: m.BookCourt })));
// const TournamentsList = lazy(() => import('../features/tournaments/Tournaments').then((m) => ({ default: m.TournamentsList })));
// const TournamentReg   = lazy(() => import('../features/tournaments/Tournaments').then((m) => ({ default: m.TournamentRegister })));
// const LiveMatches     = lazy(() => import('../features/live-matches/LiveMatches'));
// const CoachesList     = lazy(() => import('../features/coaches/Coaches').then((m) => ({ default: m.CoachesList })));
// const BookCoach       = lazy(() => import('../features/coaches/Coaches').then((m) => ({ default: m.BookCoach })));
// const MyTournaments   = lazy(() => import('../features/my-tournaments/MyTournaments'));
// const MyBookings      = lazy(() => import('../features/my-bookings/MyBookings'));
// const Profile         = lazy(() => import('../features/profile/Profile'));
// const Login           = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.Login })));
// const Register        = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.Register })));
// const ForgotPassword  = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.ForgotPassword })));
// const AboutUs         = lazy(() => import('../features/info/about_us'));
// const ContactUs       = lazy(() => import('../features/info/contact_us'));
// const BookOneOnOne    = lazy(() => import('../features/book-one-on-one/one_on_one'));
// const Notifications   = lazy(() => import('../features/notifications/notification'));   // ← NEW


// export const publicRoutes = [
//   { path: '/login',           component: Login },
//   { path: '/register',        component: Register },
//   { path: '/forgot-password', component: ForgotPassword },
//   { path: '/',                component: Home },
//   { path: '/courts',          component: CourtsList },
//   { path: '/tournaments',     component: TournamentsList },
//   { path: '/live-matches',    component: LiveMatches },
//   { path: '/coaches',         component: CoachesList },
//   { path: '/book-one-on-one', component: BookOneOnOne },
//   { path: '/aboutus',         component: AboutUs },
//   { path: '/contactus',       component: ContactUs },
// ];


// export const protectedRoutes = [
//   { path: '/courts/:id/book',           component: BookCourt },
//   { path: '/tournaments/:id/register',  component: TournamentReg },
//   { path: '/coaches',                   component: CoachesList },
//   { path: '/coaches/:id/book',          component: BookCoach },
//   { path: '/my-tournaments',            component: MyTournaments },
//   { path: '/my-bookings',               component: MyBookings },
//   { path: '/profile',                   component: Profile },
//   { path: '/notifications',             component: Notifications },  // ← NEW
// ];
import { lazy } from 'react';

const Home            = lazy(() => import('../features/home/Home'));
const CourtsList      = lazy(() => import('../features/courts/Courts').then((m) => ({ default: m.CourtsList })));
const BookCourt       = lazy(() => import('../features/courts/Courts').then((m) => ({ default: m.BookCourt })));
const TournamentsList = lazy(() => import('../features/tournaments/Tournaments').then((m) => ({ default: m.TournamentsList })));
const TournamentReg   = lazy(() => import('../features/tournaments/Tournaments').then((m) => ({ default: m.TournamentRegister })));
const LiveMatches     = lazy(() => import('../features/live-matches/LiveMatches'));
const CoachesList     = lazy(() => import('../features/coaches/Coaches').then((m) => ({ default: m.CoachesList })));
const BookCoach       = lazy(() => import('../features/coaches/Coaches').then((m) => ({ default: m.BookCoach })));
const MyTournaments   = lazy(() => import('../features/my-tournaments/MyTournaments'));
const MyBookings      = lazy(() => import('../features/my-bookings/MyBookings'));
const Profile         = lazy(() => import('../features/profile/Profile'));
const Login           = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.Login })));
const Register        = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.Register })));
const ForgotPassword  = lazy(() => import('../features/auth/Auth').then((m) => ({ default: m.ForgotPassword })));
const AboutUs         = lazy(() => import('../features/info/about_us'));
const ContactUs       = lazy(() => import('../features/info/contact_us'));
const BookOneOnOne    = lazy(() => import('../features/book-one-on-one/one_on_one'));
const Notifications   = lazy(() => import('../features/notifications/notification'));
const MyCreatedTournaments = lazy(() => import('../features/profile/mycreatedTournament')); // NEW
const ContactSupport = lazy(() => import('../features/contact-support/contact_support'));


export const publicRoutes = [
  { path: '/login',           component: Login },
  { path: '/register',        component: Register },
  { path: '/forgot-password', component: ForgotPassword },
  { path: '/',                component: Home },
  { path: '/courts',          component: CourtsList },
  { path: '/tournaments',     component: TournamentsList },
  { path: '/live-matches',    component: LiveMatches },
  { path: '/coaches',         component: CoachesList },
  { path: '/book-one-on-one', component: BookOneOnOne },
  { path: '/aboutus',         component: AboutUs },
  { path: '/contactus',       component: ContactUs },
];


export const protectedRoutes = [
  { path: '/courts/:id/book',           component: BookCourt },
  { path: '/tournaments/:id/register',  component: TournamentReg },
  { path: '/coaches',                   component: CoachesList },
  { path: '/coaches/:id/book',          component: BookCoach },
  { path: '/my-tournaments',            component: MyTournaments },
  { path: '/my-bookings',               component: MyBookings },
  { path: '/profile',                   component: Profile },
  { path: '/notifications',             component: Notifications },
  { path: '/my-created-tournaments',    component: MyCreatedTournaments },
   { path: '/contact-support',           component: ContactSupport },  // NEW
];